import React from "react";

const PinterestBrand2 = ({ width = 32, height = 32 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_3329_131909)">
      <path
        d="M27.6364 0H4.36364C1.95367 0 0 1.95367 0 4.36364V27.6364C0 30.0463 1.95367 32 4.36364 32H27.6364C30.0463 32 32 30.0463 32 27.6364V4.36364C32 1.95367 30.0463 0 27.6364 0Z"
        fill="#D50012"
      />
      <path
        d="M16.4687 6C11.0142 6 8.25781 9.91273 8.25781 13.1764C8.25781 15.1527 9.00509 16.9091 10.6105 17.5655C10.6664 17.5949 10.7286 17.6106 10.7918 17.611C10.855 17.6114 10.9174 17.5967 10.9737 17.568C11.03 17.5393 11.0786 17.4975 11.1154 17.4461C11.1522 17.3947 11.1761 17.3353 11.1851 17.2727C11.2396 17.0709 11.3669 16.5618 11.4196 16.3509C11.4978 16.0618 11.4669 15.9618 11.2542 15.7109C10.7924 15.1655 10.496 14.4582 10.496 13.4582C10.496 10.5491 12.6778 7.95455 16.1524 7.95455C19.2433 7.95455 20.9324 9.84 20.9324 12.3582C20.9324 15.6709 19.4669 18.4655 17.296 18.4655C16.0942 18.4655 15.1942 17.4709 15.4778 16.2527C15.8233 14.7982 16.4924 13.2273 16.4924 12.1764C16.4924 11.2364 15.9869 10.4509 14.9433 10.4509C13.7142 10.4509 12.7269 11.7236 12.7269 13.4255C12.7181 14.0504 12.8421 14.6701 13.0905 15.2436C13.0905 15.2436 11.8324 20.5691 11.6124 21.5036C11.1742 23.36 11.5469 25.6382 11.5778 25.8673C11.5826 25.8968 11.596 25.9243 11.6163 25.9463C11.6366 25.9682 11.6629 25.9838 11.692 25.9909C11.721 25.9981 11.7515 25.9966 11.7797 25.9866C11.8079 25.9765 11.8325 25.9584 11.8505 25.9345C11.9651 25.7855 13.4269 23.98 13.9251 22.1745C14.0651 21.6636 14.7324 19.0164 14.7324 19.0164C15.1324 19.7782 16.2978 20.4491 17.5396 20.4491C21.2324 20.4491 23.7378 17.0818 23.7378 12.5764C23.7414 9.17273 20.8542 6 16.4687 6Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_3329_131909">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default PinterestBrand2;
